export function mapInit(){
	const mapContainer = $('#map'),
		zoomInButton = $('.js-mapControlPlus'),
		zoomOutButton = $('.js-mapControlMinus'),
		mapMarkers = mainContactMarkers;

	var mapCenter = mapContainer.data('center').split(','),
		mapCenter = [mapCenter[0],mapCenter[1]];

	const map = new ymaps.Map(mapContainer[0], {
        center: mapCenter,
        zoom: 15,
        controls: []
    }, {suppressMapOpenBlock: true});

    zoomInButton.on('click', function() {
		if(map.getZoom() > 18) return false;
		map.setZoom(map.getZoom() + 1);
	});

	zoomOutButton.on('click', function() {
		if(map.getZoom() < 5) return false;
		map.setZoom(map.getZoom() - 1);
	});

    $(window).width() <= 767 && map.behaviors.disable('drag');

	/*
	 * Добавление меток на карту
	 */

	function addMarkers(markers){
		$.each(markers, function(i){
			const location = markers[i].location;
			const pin = markers[i].pin;
			const pinSize = [50, 60];
			const pinOffset = [-25, -60];

			const marker = new ymaps.Placemark(location, {}, {
   				iconLayout: 'default#imageWithContent',
	            iconImageHref: pin,
	            iconImageSize: pinSize,
	            iconImageOffset: pinOffset
	        });

            map.geoObjects.add(marker);
		});
	}

	addMarkers(mapMarkers);
}
